<template>
  <div :class="'custom_input '+width">
    <div
      v-if="capitalisedLabel !== ''"
      class="label"
    >
      {{ capitalisedLabel }}
    </div>
    <multiselect
      v-model="value"
      :can-clear="false"
      :close-on-select="closeOnSelect"
      :max="max"
      :mode="mode"
      :no-results-text="''"
      :options="options"
      :placeholder="placeholder"
      :searchable="true"
      :disabled="disabled"
      class="custom-multiselect"
      @change="(updatedValue) => useShortDebounce ? shortDebounce(updatedValue) : longDebounce(updatedValue)"
    >
      <template #caret>
        <i class="icon arrow_down_icon caret" />
      </template>
    </multiselect>
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >{{ error }}</small>
  </div>
</template>

<script>

import _ from 'lodash';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please Select'
    },
    mode: {
      type: String,
      required: false,
      default: 'single'
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Array, String],
      default: () => []
    },
    options: {
      type: [Array, Object, Function],
      required: true
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null,
    },
    max: {
      type: Number,
      required: false,
      default: -1
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    useShortDebounce: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (this.useShortDebounce) {
          this.shortDebounce(value);
        } else {
          this.longDebounce(value);
        }
      }
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value);
    },
    shortDebounce: _.debounce(function (value) {
      this.updateValue(value);
    }, 0),
    longDebounce: _.debounce(function (value) {
      this.updateValue(value);
    }, 500)
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.custom_input {
  margin-bottom: 1.5rem;
  color: #4E4E54;
}

.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.caret {
  margin-right: 24.5px;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.custom-multiselect {
  --ms-ring-width: 0px;

  --ms-font-size: 1rem;
  --ms-line-height: 1.375;

  --ms-tag-bg: #37B2A8;
  --ms-bg-disabled: #E9ECEF;
  --ms-border-color: #E8E5E2;
  --ms-border-width: 1px;
  --ms-radius: .75rem;
  --ms-py: 12.5px;
  --ms-px: 24.5px;

  --ms-tag-font-size: 14px;
  --ms-tag-line-height: 14px;
  --ms-tag-font-weight: 400;

  --ms-option-font-size: 14px;
  --ms-option-line-height: 14px;
  --ms-option-bg-selected-pointed: #37B2A8;
  --ms-option-bg-selected-disabled: #FFFFFF;
  --ms-option-color-pointed: #1F2937;
  --ms-option-color-selected: #FFFFFF;
  --ms-option-color-disabled: #D1D5DB;
  --ms-option-color-selected-pointed: #FFFFFF;
  --ms-option-color-selected-disabled: #D1FAE5;
  --ms-option-py: 0.5rem;
  --ms-option-px: 0.75rem;
}

.custom_input :deep(.is-disabled) {
  opacity: .5;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}
</style>
